export default __webpack_public_path__ + "static/media/facebook.a3083aad.svg";